var wSize = $(window).outerWidth();
var hSize = $(window).innerHeight();

$(document).on('shopify:section:load', function() {

    /* NEWSLETTER -------------------------------- */

    const nl_url = new URL(window.location.href);
    if (nl_url.searchParams.get('form_type') === 'customer') {
        $('.nl-status').removeClass('hidden');
    }

    /* ADJUST SELECT ----------------------------- */

    function adjustWidth($select) {
        let $widthSpan = $select.siblings(".select-width");
        $widthSpan.text($select.find("option:selected").text());
        $select.width($widthSpan.outerWidth() + 20);
    }

    $('.footer .switcher select').each(function () {
        adjustWidth($(this)); // Initialize width
    });

    $('.footer .switcher select').on("change", function () {
        adjustWidth($(this));
    });

    /* PRELOADER --------------------------------- */

    if ($('.preloader').length) {

        preloaderLine();
        $('body').css('overflow-y', 'hidden');

        setTimeout(() => {
            $('.preloader .line.one').fadeIn(500);
        }, 500);
        setTimeout(() => {
            preloaderLine_2();
        }, 1500);

        $('.preloader .line.two').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
            $('.preloader').css('background', 'transparent');

            $('.preloader .top').css({
                'top': '-100%',
                'right': '-100%'
            });
            $('.preloader .bottom').css({
                'bottom': '-100%',
                'left': '-100%'
            });

            $('.preloader .line').hide();
        });

        $('.preloader .pie').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
            $('.preloader').hide();
            $('body').css('overflow-y', 'visible');
        });
    }

    /* LOOX REVIEWS ------------------------------ */

    if ($('#looxReviews').length) {
        $('#looxReviews').parent().attr('data-scrollspy', 'Reviews').addClass('container section-content');
    }

    /* DATA AOS ---------------------------------- */

    $('[data-aos]').addClass('aos-init');

    /* Header Height ----------------------------- */
    
    let headerH = $('.header').height();
    $('body').css('padding-top', `${headerH}px`);

    $('.sticky-top').css('top', `${headerH + 30}px`);
    $('.nav-mobile').css('height', `${hSize - headerH}px`);

    /* Scroll Spy ------------------------------- */
    
    if ($('.product-nav').length) {
        let uniqueValues = [...new Set($('[data-scrollspy]').map(function() {
            return $(this).data('scrollspy');
        }).get())];
    
        let htmlContent = uniqueValues.map(function(value) {
            return `<a href="javascript:void(0)" data-anchor=\"${value}\"">${value}</a>`;
        }).join('');
    
        $('.product-nav .nav').html(htmlContent);
    }

    /* Mega Menu -------------------------------- */

    if ($('.mega-navs').length) {
        $('.mega-navs .mega-nav:first-child').addClass('active');
    }
    if ($('.mega-tabs').length) {
        $('.mega-tabs .mega-tab:first-child').addClass('active');
    }

    /* Footer ---------------------------------- */

    if ($('.footer').length) {
        let owl_accessory = $('.footer .owl-carousel').owlCarousel({
            items: 5,
            nav: false,
            dots: false,
            smartSpeed: 800,
            margin: 10,
            responsive: {
                0: {
                    items: 1,
                    dots: true,
                },
                768: {
                    items: 2,
                    dots: true,
                },
                1280: {
                    items: 5,
                    dots: false,
                }
            }
        });
    }

    /* Page Content --------------------------------------------------- */

    $('.page-content img').each(function () {
        const altValue = $(this).attr('alt');
        if (altValue) {
            const sanitizedAlt = altValue.trim().replace(/\s+/g, '-').toLowerCase();
            $(this).addClass(sanitizedAlt);
        }
    });

    $('.page-content table').each(function () {
        if (wSize < 768) {
            $(this).css('width', '100%');
        }
    });

    scrollSpy();
    displayRecentlyViewed();
    backToTop();
});

$(document).ready(function() {

    /* NEWSLETTER -------------------------------- */

    const nl_url = new URL(window.location.href);
    if (nl_url.searchParams.get('form_type') === 'customer') {
        $('.nl-status').removeClass('hidden');
    }

    /* ADJUST SELECT ----------------------------- */

    function adjustWidth($select) {
        let $widthSpan = $select.siblings(".select-width");
        $widthSpan.text($select.find("option:selected").text());
        $select.width($widthSpan.outerWidth() + 20);
    }

    $('.footer .switcher select').each(function () {
        adjustWidth($(this)); // Initialize width
    });

    $('.footer .switcher select').on("change", function () {
        adjustWidth($(this));
    });

    /* PRELOADER --------------------------------- */

    if ($('.preloader').length) {

        preloaderLine();
        $('body').css('overflow-y', 'hidden');

        setTimeout(() => {
            $('.preloader .line.one').fadeIn(500);
        }, 500);
        setTimeout(() => {
            preloaderLine_2();
        }, 1500);

        $('.preloader .line.two').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
            $('.preloader').css('background', 'transparent');

            $('.preloader .top').css({
                'top': '-100%',
                'right': '-100%'
            });
            $('.preloader .bottom').css({
                'bottom': '-100%',
                'left': '-100%'
            });

            $('.preloader .line').hide();
        });

        $('.preloader .pie').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
            $('.preloader').hide();
            $('body').css('overflow-y', 'visible');
        });
    }

    /* LOOX REVIEWS ------------------------------ */

    if ($('#looxReviews').length) {
        $('#looxReviews').parent().attr('data-scrollspy', 'Reviews').addClass('container section-content');
    }

    /* DATA AOS ---------------------------------- */

    $('[data-aos]').addClass('aos-init');

    /* Header Height ----------------------------- */
    
    let headerH = $('.header').height();
    $('body').css('padding-top', `${headerH}px`);

    $('.sticky-top').css('top', `${headerH + 30}px`);
    $('.nav-mobile').css('height', `${hSize - headerH}px`);

    /* Scroll Spy ------------------------------- */
    
    if ($('.product-nav').length) {
        let uniqueValues = [...new Set($('[data-scrollspy]').map(function() {
            return $(this).data('scrollspy');
        }).get())];
    
        let htmlContent = uniqueValues.map(function(value) {
            return `<a href="javascript:void(0)" data-anchor=\"${value}\"">${value}</a>`;
        }).join('');
    
        $('.product-nav .nav').html(htmlContent);
    }

    /* Mega Menu -------------------------------- */

    if ($('.mega-navs').length) {
        $('.mega-navs .mega-nav:first-child').addClass('active');
    }
    if ($('.mega-tabs').length) {
        $('.mega-tabs .mega-tab:first-child').addClass('active');
    }

    /* Footer ---------------------------------- */

    if ($('.footer').length) {
        let owl_accessory = $('.footer .owl-carousel').owlCarousel({
            items: 5,
            nav: false,
            dots: false,
            smartSpeed: 800,
            margin: 10,
            responsive: {
                0: {
                    items: 1,
                    dots: true,
                },
                768: {
                    items: 2,
                    dots: true,
                },
                1280: {
                    items: 5,
                    dots: false,
                }
            }
        });
    }

    /* Page Content --------------------------------------------------- */

    $('.page-content img').each(function () {
        const altValue = $(this).attr('alt');
        if (altValue) {
            const sanitizedAlt = altValue.trim().replace(/\s+/g, '-').toLowerCase();
            $(this).addClass(sanitizedAlt);
        }
    });

    $('.page-content table').each(function () {
        if (wSize < 768) {
            $(this).css('width', '100%');
        }
    });

    scrollSpy();
    displayRecentlyViewed();
    backToTop();
});

$(window).on('resize', function() {
    wSize = $(window).outerWidth();
    hSize = $(window).outerHeight();
    
    preloaderLine();

    /* Header Height ----------------------------- */
    
    let headerH = $('.header').height();
    $('body').css('padding-top', `${headerH}px`);

    $('.sticky-top').css('top', `${headerH + 30}px`);
    $('.nav-mobile').css('height', `${hSize - headerH}px`);
});

$(window).scroll(function() {
    scrollSpy();
    backToTop();
});

function scrollSpy() {
    if ($('.product-nav').length) {
        const sections = $('[data-scrollspy]');
        let currentSection = '';

        sections.each(function () {
            const sectionTop = $(this).offset().top - 500;
            const sectionHeight = $(this).height();
            if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
                currentSection = $(this).data('scrollspy');
            }
        });

        const links = $('.product-nav .nav a');
        links.removeClass('active');
        links.filter('[data-anchor="' + currentSection + '"]').addClass('active');
    }
}


// $('.atc-form').on('submit', function (event) {
//     if($('.btn-atc').hasClass('submiting')) return;
//     $('.btn-atc').addClass('submiting');

//     event.preventDefault();
//     let formData = $(this).serialize();
//     console.log('.atc-form');

//     $('.btn-atc span').css('visibility', 'hidden');
//     $('.btn-atc .atc-overlay').css('display', 'flex');


//     /* ========= 配件选购 ========= */
//         let jquery = window.jQuery;
//         let items = [];
//         let all_input = jquery('.template-product input[data-action="bundle-add-to-cart"]:checked');
//         let input_count = all_input.length;
        
//         if (input_count != 0){
//             let params = '';
//             all_input.each( function(index, ele) {
//                 let item_id = jquery(ele).attr("data-product-variant-id");
//                 let item_quantity = parseInt(jquery(ele).attr("data-product-qty"));
//                 params += "&items["+ 100+index +"]id=" + item_id;
//                 params += "&items["+ 100+index +"]quantity=" + item_quantity;
//             });
//             formData += params;
//         }
//     /* ================== */

//     console.log('lie: ', formData);

//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: formData,
//         dataType: 'json',
//         success: function (response) {
//             refreshCart();

//             $('.btn-atc span').css('visibility', 'visible');
//             $('.btn-atc .atc-overlay').css('display', 'none');
//             $('.btn-atc').removeClass('submiting');
//         },
//         error: function (xhr, status, error) {
//             console.error('Error adding product to cart:', error);
//             $('.btn-atc').removeClass('submiting');
//         },
//     });
// });

// $('.accessory-form').on('submit', function (event) {
//     event.preventDefault();
//     let formData = $(this).serialize();

//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: formData,
//         dataType: 'json',
//         success: function (response) {
//             refreshCart();
//         },
//         error: function (xhr, status, error) {
//             console.error('Error adding product to cart:', error);
//         }
//     });
// });

// function refreshCart() {
//     $.ajax({
//         type: 'GET',
//         url: window.location.href,
//         dataType: 'html',
//         success: function(cartHtml) {
//             /* let count = $('#CartCount span').html();

//             if (count != 0)
//                 $('#CartCount').removeClass('d-none');
//             else 
//                 $('#CartCount').addClass('d-none');

//             $('#CartCount span').html(count); */
//         },
//         error: function(xhr, status, error) {
//             console.error('Error fetching cart data:', error);
//         }
//     });
// }

function visiblePercent($element) {
    let windowHeight = $(window).height();
    let scrollTop = $(window).scrollTop();
    let elementOffset = $element.offset().top;
    let elementHeight = $element.outerHeight();

    let distanceFromTop = elementOffset - scrollTop;
    let visiblePercent = (windowHeight - distanceFromTop) / elementHeight * 100;

    visiblePercent = Math.max(0, Math.min(100, visiblePercent));

    return visiblePercent;
}

function sectionPercent($element) {
    let elementHeight = $element.outerHeight();
    let viewportHeight = $(window).height();
    
    let elementOffset = $element.offset();
    let elementTop = elementOffset.top - $(window).scrollTop();

    let scrollPercentage = Math.min(100, Math.max(0, ((viewportHeight - elementTop) / elementHeight) * 100));

    return scrollPercentage;
}

$('.mdl .overlay').on('click', function() {
    let parent = $(this).parent();
    parent.fadeOut();

    mld_close(parent);
});
$('.mdl .mdl-close').on('click', function() {
    let parent = $(this).closest('.mdl');
    parent.fadeOut();

    mld_close(parent);
});

function mld_close(parent) {
    if ($('.video-bg-text video').length) {
        $('.video-bg-text video')[0].play();
    }

    if (parent.data('mdl') == 'youtube') {
        $(parent.find('.youtube-wrapper iframe').remove());
    }
    if (parent.data('mdl') == 'size-fit') {
        $(parent.find('.mdl-wrapper').css('left', '100%'));
    }

    $('body').css('overflow-y', 'visible');
}

$('.header .drop1 > div > .item').on('mouseover', function() {

    let $this = $(this);
    let dropValue = $this.data('drop');

    $('.header .drop .item i').css('transform', 'scale(1)');
    $this.find('i').css('transform', 'rotate(90deg)');
    
    $('.drop2').hide();
    
    if (dropValue !== undefined) {
        let $drop = $('.drop2[data-drop="' + dropValue + '"]');
        $drop.show();
    }

});

$('.header .nav-item').on('mouseover', function() {

    $('.header .nav-items').find('.underline').css('width', '0');
    $(this).find('.underline').css('width', '100%');

    let $this = $(this);
    let dropValue = $this.data('drop');

    $('.header .nav-item i').css('transform', 'scale(1)');
    $this.find('i').css('transform', 'scale(-1)');

    $('.header .drop .item i').css('transform', 'scale(1)');
    
    $('.drop').hide();
    
    if (dropValue !== undefined) {
        let $drop = $('.drop[data-drop="' + dropValue + '"]');
        $drop.show();

        let navItemOffset = $this.offset();
        let navItemWidth = $this.outerWidth();
        let dropWidth = $drop.outerWidth();
        
        let leftPosition = navItemOffset.left + (navItemWidth / 2) - (dropWidth / 2);

        $drop.css({
            'left': leftPosition
        });
    }

});

let isMouseOverDrop = false;

$('.header .nav-items').on('mouseleave', function(event) {

    let $navItems = $(this);
    let navItemsOffset = $navItems.offset();
    let navItemsWidth = $navItems.outerWidth();
    let navItemsHeight = $navItems.outerHeight();
    let buffer = 30;

    let extendedLeft = navItemsOffset.left - buffer;
    let extendedRight = navItemsOffset.left + navItemsWidth + buffer;
    let extendedTop = navItemsOffset.top - buffer;
    let extendedBottom = navItemsOffset.top + navItemsHeight + buffer;

    $(document).on('mousemove.navItemsCheck', function(event) {
        let mouseX = event.pageX;
        let mouseY = event.pageY;

        if (mouseX < extendedLeft || mouseX > extendedRight || mouseY < extendedTop || mouseY > extendedBottom) {
            if (!isMouseOverDrop) {
                $('.drop').hide();
                $('.header .nav-item i').css('transform', 'scale(1)');
                $('.header .nav-items').find('.underline').css('width', '0');
            }
        }
    });
});

$('.header .nav-items').on('mouseenter', function() {
    $(document).off('mousemove.navItemsCheck');
});

$('.drop1').on('mouseenter', function() {
    isMouseOverDrop = true;
});

$('.drop1').on('mouseleave', function() {
    isMouseOverDrop = false;
    $('.header .nav-items').trigger('mouseleave');
});

$('.mega-nav').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');
    $('.mega-tab').hide();

    let tab = $(this).data('tab');

    $(`.mega-tab[data-tab="${tab}"]`).css('display', 'flex').hide().fadeIn();
});

$('.icon-search').on('click', function() {
    $('.predictive-search').fadeIn();
});

$('.predictive-search .overlay').on('click', function() {
    $('.predictive-search').fadeOut();
    $('.predictive-search input').val('');
});

$('.predictive-search .icon:last-child').on('click', function() {
    $('.predictive-search').fadeOut();
    $('.predictive-search input').val('');
});

$(document).on('click', '#predictive-search .view-all', function() {
    $('predictive-search form').trigger('submit');
});

$('.nav-toggle').on('click', function() {
    if ($('body').hasClass('menu-open')) {
        $('body').removeClass('menu-open');
        $('body').css('overflow-y', 'visible');
    }
    else {
        $('body').addClass('menu-open');
        $('body').css('overflow-y', 'hidden');
    }
});

$('.nav-mobile a[data-mega]').on('click', function() {
    let mega = $(this).data('mega');
    $(`.mega-mobile[data-mega="${mega}"]`).addClass('show');
});

$('.nav-mobile .mega-title').on('click', function() {
    $('.mega-mobile[data-mega]').removeClass('show');
});

$(document).on('click', '.nav-mobile .accordion-button', function (e) {
    const $target = $(e.target);

    if ($target.is('a')) {
        const href = $target.attr('href');
        
        window.location.href = href;

        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }

    const $button = $(this);
    const target = $button.attr('data-bs-target');
    $(target).collapse('toggle');
});

function preloaderLine() {
    const $line_1 = $('.preloader .line.one');
    const $line_2 = $('.preloader .line.two');

    const diagonalLength = Math.sqrt($(window).width() ** 2 + $(window).height() ** 2);
    const rotationAngle = Math.atan($(window).height() / $(window).width()) * (180 / Math.PI);

    $line_1.css({
        width: `${diagonalLength}px`,
        transform: `rotate(${rotationAngle}deg)`
    });

    $line_2.css({
        transform: `rotate(${rotationAngle}deg)`
    });
}

function preloaderLine_2() {
    const $line_2 = $('.preloader .line.two');
    const diagonalLength = Math.sqrt($(window).width() ** 2 + $(window).height() ** 2);

    $line_2.css({
        width: `${diagonalLength}px`,
    });
}

function recentlyViewed(product) {
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

    recentlyViewed = recentlyViewed.filter(item => item.productId !== product.productId);
    recentlyViewed.unshift(product);

    if (recentlyViewed.length > 5) {
        recentlyViewed.pop();
    }

    localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewed));
}

function displayRecentlyViewed() {
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
  
    if (recentlyViewed.length > 0) {
        if ($('.recently-viewed').length) {

            recentlyViewed.forEach(product => {
                $('.recently-viewed .owl-carousel').append(
                    `<div class="item">
                        ${product.html}
                    </div>`
                );
            });

            $('.recently-viewed .owl-carousel').each(function() {
                let $carousel = $(this);
                let $floatNav = $carousel.next('.float-nav');

                let owl = $carousel.owlCarousel({
                    items: 3,
                    nav: true,
                    dots: false,
                    smartSpeed: 800,
                    margin: 20,
                    responsive: {
                        0: {
                            items: 1
                        },
                        768: {
                            items: 2
                        },
                        1280: {
                            items: 3
                        }
                    }
                }).on('changed.owl.carousel', function(event) {
                    let currentIndex = event.item.index;
                    let totalItems = event.item.count;
                    let pageSize = event.page.size;

                    if (currentIndex === 0) {
                        $floatNav.find('.owl-prev').prop('disabled', true);
                    } else {
                        $floatNav.find('.owl-prev').prop('disabled', false);
                    }

                    if (currentIndex >= totalItems - pageSize) {
                        $floatNav.find('.owl-next').prop('disabled', true);
                    } else {
                        $floatNav.find('.owl-next').prop('disabled', false);
                    }
                });

                $floatNav.find('.owl-prev').on('click', function() {
                    owl.trigger('prev.owl.carousel');
                });
                $floatNav.find('.owl-next').on('click', function() {
                    owl.trigger('next.owl.carousel');
                });
            });
        }
    }
    else {
        $('.recently-viewed').hide();
    }
}

function deleteRecentlyViewed(productId) {
    // Retrieve the recentlyViewedProducts array from localStorage
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

    // Filter out the item with the matching productId
    recentlyViewed = recentlyViewed.filter(item => item.productId !== productId);

    // Save the updated array back to localStorage
    localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewed));
}

function backToTop() {
    if ($('.back-to-top').length) {
        let scrollDistance = $(window).scrollTop();
        let vh50 = $(window).height() * 0.5;

        if (wSize >= 1280) {
            if (scrollDistance >= vh50) {
                $('.back-to-top').fadeIn();
            }
            else {
                $('.back-to-top').fadeOut();
            }
        }
    }
}

$('.back-to-top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'fast');
});

let isMouseOverLocal = false;

$('.header .icon-local').on('mouseover', function() {

    if (wSize >= 1280) {
        let localTop = $('.header > .container').innerHeight() - ($('.header .icon-local').innerHeight() + ($('.header .icon-local').innerHeight()/2)) - 1;
        $('.header .icon-local .switcher').css('top', `${localTop}px`);
    }
    else {
        let localTop = ($('.header .action .icon-local .switcher').innerHeight() + 40) * -1;
        $('.header .action .icon-local .switcher').css('top', `${localTop}px`);
        $('.nav-mobile .action a i').css('transform', 'scaleY(-1)');
    }

    $('.header .icon-local .switcher').css('visibility', 'visible');
});

$('.header .icon-local').on('mouseleave', function(event) {

    let $navItems = $(this);
    let navItemsOffset = $navItems.offset();
    let navItemsWidth = $navItems.outerWidth();
    let navItemsHeight = $navItems.outerHeight();
    let buffer = 30;

    let extendedLeft = navItemsOffset.left - buffer;
    let extendedRight = navItemsOffset.left + navItemsWidth + buffer;
    let extendedTop = navItemsOffset.top - buffer;
    let extendedBottom = navItemsOffset.top + navItemsHeight + buffer;

    $(document).on('mousemove.localCheck', function(event) {
        let mouseX = event.pageX;
        let mouseY = event.pageY;

        if (mouseX < extendedLeft || mouseX > extendedRight || mouseY < extendedTop || mouseY > extendedBottom) {
            if (!isMouseOverLocal) {
                $('.header .icon-local .switcher').css('visibility', 'hidden');
                $('.nav-mobile .action a i').css('transform', 'scaleY(1)');
            }
        }
    });
});

$('.header .icon-local').on('mouseenter', function() {
    $(document).off('mousemove.localCheck');
});

$('.header .icon-local .switcher').on('mouseenter', function() {
    isMouseOverLocal = true;
});

$('.header .icon-local .switcher').on('mouseleave', function() {
    isMouseOverLocal = false;
    $('.header .icon-local').trigger('mouseleave');
});

$('.header .icon-local .switcher .country').on('click', function () {
    let href = $(this).data('href');
    console.log(href);
    if (href) {
        window.location.href = href;
    }
    else {
        let selectedCountry = $(this).data("country");
        let selectedCurrency = $(this).data("currency");

        let currentUrl = new URL(window.location.href);

        currentUrl.searchParams.set("country", selectedCountry);
        currentUrl.searchParams.set("currency", selectedCurrency);

        window.location.href = currentUrl.toString();
    }
});

$('.footer .switcher .switch-currency').on('change', function() {
    let val = $(this).val().split(' | ');
    let currentUrl = new URL(window.location.href);

    currentUrl.searchParams.set("country", val[0]);
    currentUrl.searchParams.set("currency", val[1]);
    currentUrl.searchParams.set("locale", $('.footer .switcher .switch-language').val());

    window.location.href = currentUrl.toString();
});

$('.footer .switcher .switch-language').on('change', function() {
    let val = $('.footer .switcher .switch-currency').val().split(' | ');
    let currentUrl = new URL(window.location.href);

    currentUrl.searchParams.set("country", val[0]);
    currentUrl.searchParams.set("currency", val[1]);
    currentUrl.searchParams.set("locale", $(this).val());

    window.location.href = currentUrl.toString();
});

function openJekkaChat() {
    const chatBox = document.querySelector('#hello-jekka-chat-box');

    if (chatBox && chatBox.shadowRoot) {
        const openButton = chatBox.shadowRoot.querySelector('.chat-entry-button');
        if (openButton) openButton.click();
    }
}